import Vue from 'vue'
import Router from 'vue-router'

import OnePage from '@/layouts/onePage.vue'
import MultiPage from '@/layouts/multiPage.vue'

import Sold from '@/pages/sold/sold.vue'
import PageNotFound from '@/pages/pageNotFound/pageNotFound.vue'

Vue.use(Router)

export const pages = [
  'video', 'details', 'tour360', 'gallery', 'slideshow', 'floorplan', 'walkScore', 'map', 'contact'
]

const multiPageRoutes = pages.map(name => ({
  path: `/${name === 'tour360' ? '360-tour' : name}/:id`,
  name,
  component: MultiPage
}))

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'onePage',
      component: OnePage
    },
    {
      path: '/:id',
      name: 'onePage',
      component: OnePage
    },
    ...multiPageRoutes,
    {
      path: '/sold/:id',
      name: 'sold',
      component: Sold
    },
    {
      path: '/404',
      name: 'notFound',
      component: PageNotFound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

export default router
